import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _slicedToArray from "@babel/runtime/helpers/slicedToArray";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import Breadcrumb from '../../elements/breadcrumbs';
import { useDataSelector, useEntity } from '@uswitch/ev-utils/context/selectors';
import { jsx as _jsx } from "theme-ui/jsx-runtime";

var BreadcrumbsConnected = function BreadcrumbsConnected(props) {
  var rootEntity = useDataSelector(['rootEntity']);
  var breadcrumbs = useDataSelector(['breadcrumb']);
  var path = useDataSelector(['location', 'pathname']);

  var _useDataSelector = useDataSelector(['meta', 'breadcrumbs'], {}),
      homeTitle = _useDataSelector.homeTitle,
      homePath = _useDataSelector.homePath,
      showPageTitle = _useDataSelector.showPageTitle;

  var page = rootEntity.fields.link;
  var pageEntity = useEntity(page);

  var _breadcrumbs$slice = breadcrumbs.slice(-1),
      _breadcrumbs$slice2 = _slicedToArray(_breadcrumbs$slice, 1),
      pageCrumb = _breadcrumbs$slice2[0];

  var crumbs = breadcrumbs.filter(function (bc) {
    return bc.fields.path !== path;
  });
  var breadcrumbTitle = pageCrumb.fields.path === path ? pageCrumb.fields.displayText : pageEntity.title;

  var breadcrumbsProps = _objectSpread(_objectSpread({
    crumbs: crumbs,
    title: showPageTitle ? breadcrumbTitle : null
  }, homeTitle ? {
    customHomeIcon: homeTitle
  } : {}), {}, {
    homePath: homePath,
    variant: props.variant || 'base'
  });

  return _jsx(Breadcrumb, _objectSpread(_objectSpread({}, breadcrumbsProps), {}, {
    sx: {
      variant: 'compounds.breadcrumbs'
    }
  }));
};

export default BreadcrumbsConnected;
//# sourceMappingURL=index.js.map